export const BASE_INCOMPLETE_ERROR =
  'Child Scenarios can only be created for completed base scenarios';

//header component
export const SELECT_SCENARIO = 'Please select a Scenario';
export const NO_OUTPUT_ERROR =
  'There is no output for base scenarios. Please navigate to scenario library and select a child scenario to view output data.';

//UPLOAD component
export const FILE_FORMAT_ERROR =
  "This format is not supported. Please upload '.csv' file";
export const FILE_UPLOAD_ERROR =
  'The format of uploaded data is not correct. Please check and upload again';
export const NAME_EMPTY_ERROR = 'Scenario name is empty, please fill it!';
export const NAME_CHAR_ERROR = 'Name cannot have special characters';
export const DATA_UPLOAD_CONSISTENCY_ERROR =
  'Uploaded data has failed consistency checks. Kindly correct the data and upload again.';
export const NAME_ALREADY_ERROR =
  'A base scenario with this name already exists.';
export const DATA_UPLOAD_ERROR = 'No data uploaded to check! please upload.';
export const SKU_ERROR = 'No new SKUs';
export const NO_UPLOAD_ERROR = 'No data uploaded!!';
export const RECHECK_NAME_ERROR =
  'You changed the scenario name after checking consistency. Please recheck.';
export const DATA_CHECK_ERROR = 'Kindly perform the data check first.';
export const CONSISTENCY_ERROR =
  'Your data does not pass all consistency checks.';
export const SAVE_SUCCESS = ' base scenario saved successfully !!!';
export const SAVE_ERROR = 'An error occured while saving this Base Scenario!!';

//output component
export const ERROR = 'Something went wrong!';
export const NO_FILTER_SELECTED = 'Please select a filter';
export const DATA_DOESNT_EXIST = 'Data for selected timeperiod does not exist';

// new scenario component
export const DELETE_SURE = 'Are you sure you want to delete this scenario?';
export const SURE = '<strong>Sure?</strong>';
export const BASE_DELETE_SUCCESS = ' base scenario deleted successfully !!!';
export const DATA_ERROR =
  "Couldn't find the specific data in json base scenario";
export const BASE_ERROR = ' base scenario was deleted by some other user !!!';
export const BASE_DELETE_ERROR = 'User is not authorized to delete the base';
export const BASE_DELETE_CHECK =
  ' was created by some other user. You cannot delete base scenarios created by others.';
export const CHILD_DELETE_SUCCESS = ' child scenario deleted successfully !!!';
export const CHILD_ERROR = ' child scenario was deleted by some other user !!!';
export const CHILD_DELETE_ERROR = 'User is not authorized to delete the child';
export const CHILD_DELETE_CHECK =
  ' was created by some other user. You cannot delete child scenarios created by other users.';
export const CALCULATION_ERROR =
  'Calculations running in the background.\nPlease try after sometime !!!';

// data-table component
export const CHILD_NAME_EMPTY = 'Child Scenario name is empty.';
export const CHILD_NAME_ERROR =
  'Only letter, numbers and underscore are allowed characters in child scenario name.';
export const PRICE_ERROR = 'Some scenario prices are negative !!!';
export const CHILD_SAVE_SUCCESS = ' child scenario saved successfully !!!';
export const CHILD_EXIST_ERROR = ' child scenario already exists !!!';
export const CHILD_SAVE_ERROR =
  'Particular scenario is not saved, please save first';
export const CHILD_SCENARIO_EXCEED_LIMIT =
  'Child Scenario limit has been exceeded';

export const NAV_ITEMS = [];

export const SCENARIO_BUILDER_CONSTS = {
  BUSINESS_SEGMENT: 'business_segment',
  SUPPLIER: 'supplier',
  SUBCHANNEL: 'subchannel',
  PRODUCT_CATEGORY: 'product_category',
  MATERIAL_DESCRIPTION: 'material_description',
  BRAND: 'brand',
  LINE: 'line_mapped',
  PRESENTATION: 'presentation_desc_en',
  BASE_NSR: 'base_nsr',
  BASE_GP: 'base_gp',
  VOLUME_IN_UNITS: 'volume_in_units',
  VOLUME: 'volume',
  VALUE: 'value',
  PASS_THROUGH_RATE: 'passth_rate',
  PRICE_ELASTICITY: 'price_elasticity',
  BASE_PRICE: 'price_per_unit',
  SCENARIO_PRICE: 'scenario_price',
  PERCENT_PRICE_CHANGE: 'percent_change',
};
export const COLOR = {
  DISABLED: '#777777',
  ENABLED: '#fa4b58',
};
export const SCENARIO_LIBRARY_CONSTS = {};
export const ROUTES = {
  AUTH_RESPONSE: 'auth-response',
  SCENARIO_LIBRARY: 'scenario-library',
  SCENARIO_BUILDER: 'scenario-builder',
  SCENARIO_OUTPUT: 'scenario-output',
  NEW_BASE_SCENARIO: 'upload',
  FINANCIAL_PLANNER: 'financial-planner',
  PURCHASE_STRUCTURE: 'purchase-structure',
  PRICE_ELASTICITY: 'pe-decomposition',
  SWITCHING_MATRIX: 'switching-matrix',
  DASHBOARD: 'dashboard',
};

export const PERIOD_DATA = 'period_data';
export const PERIOD_DATA_DISTRIBUTION = 'period_data_distribution';

export const STATIC_KEYS = {
  BRAND_HOUSE: 'BrandHouse',
  BRAND_PACK_VARIANT: 'BrandPackVariant',
  PRICE_SECTOR: 'PriceSector',
  TAR_LEVEL: 'TarLevel',
  RETAILER: 'retailer',
  LENGTH_BAND: 'LengthBand',
  PACK_CONTENTS: 'PackContents',
  MANFACTURER: 'Manufacturer',
  BRAND: 'Brand',
  BASE_PRICE: 'Base_Price',
  BASE_DISTRIBUTION: 'base_distribution',
  CATEGORY: 'Category',
  VOLUME: 'Base_Units',
  BRAND_VARIANT: 'BrandVariant',
};
export const STATIC_KEYS2 = {
  BRAND_HOUSE: 'Brand',
  BRAND_PACK_VARIANT: 'SKU Description',
  PRICE_SECTOR: 'Price Sector',
  TAR_LEVEL: 'Lead Amount',
  RETAILER: 'Retailer',
  LENGTH_BAND: 'Pack Size Bucket',
  PACK_CONTENTS: 'Pack Size',
  MANFACTURER: 'Manufacturer',
  BRAND: 'Brand',
  BASE_PRICE: 'Base Price',
  BASE_DISTRIBUTION: 'base_distribution',
  CATEGORY: 'Category',
  VOLUME: 'Base_Units',
  BRAND_VARIANT: 'Sub Brand',
};

export const STATIC_DISPLAY_KEYS = {
  BRAND_HOUSE: 'Brand House',
  BRAND_PACK_VARIANT: 'Brand Pack Variant',
  PRICE_SECTOR: 'Price Sector',
  TAR_LEVEL: 'Tar Level',
  RETAILER: 'Retailer',
  LENGTH_BAND: 'Length Band',
  PACK_CONTENTS: 'Pack Contents',
  MANFACTURER: 'Manufacturer',
  BRAND: 'Brand',
  BASE_PRICE: 'Base_Price',
  BASE_DISTRIBUTION: 'Base Distribution',
  CATEGORY: 'Category',
  BRAND_VARIANT: 'Brand Variant',
};
export const priceIncreaseDetailsDisplayMapper = {
  retailer: 'Retailer',
  Manufacturer: 'Manufacturer',
  PriceSector: 'Price Sector',
  BrandHouse: 'Brand Segment',
  BrandPackVariant: 'SKU Description',
  TarLevel: 'Tar Level',
  LengthBand: 'Length Band',
  PackContents: 'Pack Contents',
  Brand: 'Brand',
  Base_Price: 'Base_Price',
  Category: 'Category',
  [STATIC_KEYS.BRAND_VARIANT]: STATIC_DISPLAY_KEYS.BRAND_VARIANT,
};
export const PRICE_CHANGE_MAPPER = {
  POST_CODE_PLAN: 'Post Code Plan',
  PCM: 'PCM',
  MPI: 'MPI',
};

export const SCENARIO_KEYS_MAPPER = {
  CATEGORY: 'category',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PRICE: 'price',
};

export const MPI_MONTH_MAPPER = {
  M01: 'Jan',
  M02: 'Feb',
  M03: 'Mar',
  M04: 'Apr',
  M05: 'May',
  M06: 'Jun',
  M07: 'Jul',
  M08: 'Aug',
  M09: 'Sep',
  M10: 'Oct',
  M11: 'Nov',
  M12: 'Dec',
};

export const MONTH_MPI_MAPPER: Record<string, string> = {
  Jan: 'M01',
  Feb: 'M02',
  Mar: 'M03',
  Apr: 'M04',
  May: 'M05',
  Jun: 'M06',
  Jul: 'M07',
  Aug: 'M08',
  Sep: 'M09',
  Oct: 'M10',
  Nov: 'M11',
  Dec: 'M12',
};

export const MPI_MONTH_MAPPER2 = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
};

export const PREVIOUS_YEAR_SALES = 'Previous Year Sales';

export const LATEST_MONTH_SALES = 'Latest Month Sales';

export const PERIOD_COLS_INDEX = 11;

export const REGION_LEADER = 'Region Leader';

export const priceDynamicFilters = {
  category: ['Baby Diapers', 'Toilet Rolls'],
  brand: ['Huggies'],
  sku: ['Sku1'],
  tier: ['Alto'],
  tipo: ['PPK'],
  mt: ['RN'],
};
